import { normalizeExternalUrl } from "../domain/domainRouting";

export function resolveImageHref(value?: string): string | null {
  if (!value) return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  const normalized = trimmed.startsWith("/")
    ? new URL(trimmed, window.location.origin).toString()
    : normalizeExternalUrl(trimmed);
  if (!normalized) return null;

  try {
    const parsed = new URL(normalized, window.location.origin);
    return parsed.protocol === "https:" || parsed.protocol === "http:"
      ? parsed.toString()
      : null;
  } catch {
    return null;
  }
}

export function loadImageHref(value?: string): Promise<string | null> {
  const href = resolveImageHref(value);
  if (!href) return Promise.resolve(null);

  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(href);
    image.onerror = () => resolve(null);
    image.src = href;
  });
}

export async function firstLoadableImageHref(
  values: Array<string | undefined>,
): Promise<string | null> {
  for (const value of values) {
    const href = await loadImageHref(value);
    if (href) return href;
  }

  return null;
}

export function setDocumentLink(rel: string, rawHref: string) {
  const href = resolveImageHref(rawHref);
  if (!href) return;

  let link = document.querySelector(
    `link[rel="${rel}"]`,
  ) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
}
